import { Dialog } from "@inductiveautomation/ws-components";
import { useTranslation } from "react-i18next";

import { OrganizationsDialogProps } from "./Organizations.types";
import { countInWords } from "../../utilities/word_for_number";

const OrganizationsDialog = ({
  testId,
  selectedMemberships,
  type,
  onCancel,
  onSubmit,
}: OrganizationsDialogProps) => {
  const { t } = useTranslation();
  const firstName =
    selectedMemberships.length > 0
      ? selectedMemberships[0].organization.orgName
      : "";

  const headline =
    type === "leave_multiple_organizations"
      ? t("organizations.actions.leave_multiple_organizations.heading", {
          organizationCount: countInWords(selectedMemberships.length),
        })
      : t(`organizations.actions.${type}.heading`);

  return (
    <Dialog
      testId={testId}
      headline={headline}
      isOpen={true}
      supportingText={t(`organizations.actions.${type}.description`, {
        organizationName: firstName,
      })}
      showCloseButton
      onClose={onCancel}
      actions={[
        {
          label: t("organizations.actions.cancel.label"),
          type: "cancel",
        },
        {
          label: t(`organizations.actions.${type}.submit_label`),
          type: "submit",
          onClick: onSubmit,
        },
      ]}
    />
  );
};

export default OrganizationsDialog;
